/**
 * Task status-transition table.
 *
 * Mirrors `backend/src/domain/tasks/status.ts` so the client can grey
 * out moves the server would reject. Lifted out of
 * `components/shared/SlideOver.tsx` in PR #37 so the slide-over and the
 * Tasks Table inline-edit cells share one source of truth. Reference:
 * spec section 5.3.
 *
 * Keys are the current status; the array lists every status the user
 * may move to (the current value is included so the select can render
 * the current row without flagging it as a forward transition).
 */

import type { TaskStatus } from '@workspace/shared';

/**
 * Map from a task's current status to the set of statuses it may move
 * to. Re-exported from any surface that renders a status select so the
 * disabled-option list stays in sync with the backend guard.
 */
export const STATUS_TRANSITIONS: Record<TaskStatus, TaskStatus[]> = {
  BACKLOG: ['BACKLOG', 'TODAY', 'DOING', 'WAITING', 'DONE'],
  TODAY: ['TODAY', 'BACKLOG', 'DOING', 'WAITING', 'DONE'],
  DOING: ['DOING', 'TODAY', 'WAITING', 'DONE'],
  WAITING: ['WAITING', 'BACKLOG', 'TODAY', 'DOING', 'DONE'],
  DONE: ['DONE', 'BACKLOG', 'TODAY', 'DOING', 'WAITING'],
};
